import { useState, useEffect } from "react"
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contextos/AuthProvider'
import { TiposDocumentoExoneracion, TiposID, tiposTributario, Provincias, EncApi, EncabezadoPost, CodigosTarifasDiferenciadas, InstitucionesExoneran } from "../Comunes/Listas";
import Swal from 'sweetalert2'
import axios from 'axios';

const FichaCliente = (props) => {

    //let today = HoraServidor() ;
    //console.log(today);
    //today.then(result => console.log(result));

    const navigate = useNavigate();
    const { PerfilUsuario, Token } = useAuth();
    const ObjetoBase = {
        CON_CODIGO: PerfilUsuario.IdCia,
        FAC_CED_CLI: '',
        FAC_FAC_NOMBRE: '',
        FAC_TIPO_CL: '1',
        FAC_FAC_CORREO: '',
        FAC_FAC_TELEFONO: '',
        PROVINCIA: 1,
        CANTON: 1,
        DISTRITO: 1,
        OTRAS_OTRAS_DIRECCIONESES: '',
        FAC_NOMBRE_COMERCIAL: '',
        TIPO_TRIBUTARIO: '1',
        ETipoDoc: '08',
        ENumDoc: '',
        Einstitucion: '01',
        EFechaEmision: '2025-01-01',
        EPorcentaje: 0
        , Articulo: '0'
        , Inciso: '0',
        DE_TASA_IMP: '08'
    }

    const [Gestor, setGestor] = useState(ObjetoBase)
    const Modificar = (e) => {
        const { name, value, type } = e.target;
        setGestor({ ...Gestor, [name]: (type === 'number') ? parseInt(value) : value });
        //console.log(props.EntidadActual);
    }

    const ModificarActividad = (e) => {
        const { value } = e.target;
        setActSelected(value);
        //console.log(Gestor);
    }
    const ConsultaCedula = async () => {
        const URL = 'https://SmartFeCr.com:2020/SmartContrackBack/api/Socios/ObtenerUnCliente?IdCia=' + PerfilUsuario.IdCia + '&Cedula=' + Gestor.FAC_CED_CLI
        const resp = await fetch(URL, EncApi(Token)).then(response => response.json())
        return resp
    }
    const ZonaProvincia = async (e) => {
        const { value } = e.target;
        axios.get(`https://SmartFeCr.com:2020/SmartContrackBack/api/Companias/CantonesDeProvincia?Id=${value}`, EncApi(Token))
            .then(res => {
                const { data } = res;
                console.log(data);
                setCantones(data.CantonesVecinos);
                setDistritos(data.DistritosVecinos);

            });
        setGestor({ ...Gestor, "PROVINCIA": value, "CANTON": "1", "DISTRITO": "1" });
    }
    const ZonaCanton = async (e) => {

        const { value } = e.target;
        axios.get(`https://SmartFeCr.com:2020/SmartContrackBack/api/Companias/DistritosDeCanton?IdProvincia=${Gestor.PROVINCIA}&idCanton=${value}`, EncApi(Token))
            .then(res => {
                const { data } = res;

                setDistritos(data);
                setGestor({ ...Gestor, "CANTON": value, "DISTRITO": "1" });

            });


    }

    const handleOnSubmit = async (e) => {

        if (e.which === '13') {
            e.preventDefault();
        }
        e.preventDefault();
    };
    const Salir = () => {
        navigate("/Clientes/GeneralCliente");
    }

    const TraerInfoCliente = async () => {
        const Resp = await ConsultaCedula();
        console.log(Resp);
        switch (Resp.Codigo) {
            case 0:
                props.CambiaCia(Gestor.FAC_CED_CLI)
                //navigate("/Clientes/FichaCliente");
                await ParametrosInicialesCarga(Gestor.FAC_CED_CLI)
                Swal.fire({
                    icon: 'success',
                    title: 'Ya este cliente existe, aca le cargo los datos actuales',
                    text: Resp.Mensaje,
                    timer: 2000
                })
                break;
            case 100:
                props.CambiaCia("")
                setGestor({ ...Gestor, "FAC_NOMBRE": Resp.Datos.cliente.FAC_NOMBRE, "FAC_TIPO_CL": Resp.Datos.cliente.FAC_TIPO_CL, "CON_CODIGO": PerfilUsuario.IdCia });
                setActividadesCli(Resp.Datos.actividades);
                break;
            default:
                props.CambiaCia("")
                Swal.fire({
                    icon: 'error',
                    title: 'Alerta...',
                    text: Resp.Mensaje
                })
                break;
        }

    }

    const RefrescarActivides = async () => {
        const URL = 'https://api.hacienda.go.cr/fe/ae?identificacion=' + Gestor.FAC_CED_CLI
        await fetch(URL).then(response => response.json())
            .then(json => {
                //console.log(json);
                if (json.actividades) {
                    const actividades = json.actividades.map(act => ({
                        CON_CODIGO: PerfilUsuario.IdCia,
                        FAC_CED_CLI: Gestor.FAC_CED_CLI,
                        CODIGO_ACTIVIDAD: act.codigo,
                        NOMBRE_ACTIVIDAD: act.descripcion
                    }));
                    setActividadesCli([]);
                    setActividadesCli(actividades);

                }
            })
    }


    const [Cantones, setCantones] = useState([]);
    const [Distritos, setDistritos] = useState([]);
    const [ActividadesCli, setActividadesCli] = useState([]);
    const [ActSelected, setActSelected] = useState(null);

    const ParametrosInicialesCarga = async (cedula) => {

        //

        let URL = 'https://SmartFeCr.com:2020/SmartContrackBack/api/Companias/ParametrosInicialesCarga?IdCia=' + PerfilUsuario.IdCia + '&Cedula=' + cedula

        // console.log(URL);
        await fetch(URL, EncApi(Token)).then(response => response.json())
            .then(json => {

                if (json.Codigo === 0) {
                    // console.log(json.Datos.HoraServidor);
                    setCantones(json.Datos.Cantones)
                    setDistritos(json.Datos.Distritos)
                    setActividadesCli(json.Datos.actividades);
                    if (cedula === '') {
                        setGestor({
                            ...Gestor,
                            "PROVINCIA": json.Datos.Provincia,
                            "CANTON": json.Datos.Provincia,
                            "DISTRITO": json.Datos.Distrito,
                            "EFechaEmision": json.Datos.HoraServidor.split('T')[0]
                        });
                    }
                    else {
                        setGestor(json.Datos.Cliente);
                    }
                }
            })


    };
    const GuadarCliente = async () => {
        Swal.fire({
            title: '¿Seguro en guardar los datos de cliente?',
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: 'Si, de acuerdo',
            denyButtonText: `No, Cancelar`,
        }).then(async (result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
                //console.log(JSON.stringify(Gestor))
                const URL = props.EntidadActual === "" ? 'https://SmartFeCr.com:2020/SmartContrackBack/api/Socios/NuevoCliente' : 'https://SmartFeCr.com:2020/SmartContrackBack/api/Socios/ActualizarCliente'
                let cliente = {
                    Cliente: Gestor,
                    Actividades: ActividadesCli
                }
                //console.log(URL);
                console.log(cliente);
                await fetch(URL, EncabezadoPost(Token, cliente)).then(response => response.json())
                    .then(json => {
                        console.log(json);
                        if (json.Codigo === 0) {
                            Swal.fire({
                                position: 'center',
                                icon: 'success',
                                title: 'Cliente Guardado',
                                showConfirmButton: false,
                                timer: 1500
                            })
                            navigate("/Clientes/GeneralCliente");
                        }
                        else {
                            Swal.fire({
                                icon: 'error',
                                title: 'Alerta...',
                                text: json.Mensaje + " InnerEx " + json.Objeto

                            })
                        }
                    })
            }
        })

    }



    useEffect(() => {

        if (PerfilUsuario) {
            //console.log(Rol)
            ParametrosInicialesCarga(props.EntidadActual)
        }
        // eslint-disable-next-line
    }, [])



    if (PerfilUsuario) {
        return (<div className='main-block'>
            <div className="form" onSubmit={(e) => handleOnSubmit(e)}>
                <div className='formadoShadow'>

                    <div className='tituloPantalla'>
                        <p style={{ display: 'inline-block' }}> Administración Datos Clientes</p>
                        <button className="botonCerrar" style={{ backgroundColor: '#f3f3f3', width: '50px' }} id="SalirHome" onClick={Salir} name="SalirHome"><i className="fa fa-times"></i></button>
                    </div>
                    <div className="row">
                        <div className="col-25">
                            <button id="Guardar" onClick={() => GuadarCliente()} name="Guardar">Guardar</button>
                        </div>
                        <div className='col-75'></div>
                    </div>
                    <div className="row">

                        <div className="col-25">
                            <span className="col-form-span" >N° Identificación </span>
                            <input type="text"
                                id="FAC_CED_CLI"
                                onBlur={TraerInfoCliente}
                                name="FAC_CED_CLI"
                                autoComplete='off'
                                title="Cédula sin guiones ni espacios. Física: 9 dígitos, Jurídica:10 dígitos Dimex/NITE: 11 o 12 dígitos"
                                value={Gestor.FAC_CED_CLI}
                                onChange={Modificar}></input>
                        </div>
                        <div className="col-25">
                            <span className="col-form-span" >Tipo Identificación </span>
                            <select id="FAC_TIPO_CL" name="FAC_TIPO_CL" className="form-group" onChange={Modificar} value={Gestor.FAC_TIPO_CL}>
                                {TiposID.map((option, i) => (
                                    <option key={i} value={option.value}>{option.span}</option>
                                ))}</select>
                        </div>
                        <div className="col-50">
                            <span className="col-form-span" >Nombre </span>
                            <input type="text" id="FAC_NOMBRE" name="FAC_NOMBRE" autoComplete='off' value={Gestor.FAC_NOMBRE} onChange={Modificar}></input>

                        </div>
                    </div>
                    <div className="row">


                        <div className="col-50">
                            <span className="col-form-span" >Correo </span>

                            <input
                                type="text"
                                id="FAC_CORREO"
                                name="FAC_CORREO"
                                autoComplete='off'
                                value={Gestor.FAC_CORREO}
                                onChange={Modificar}
                                onBlur={(e) => {
                                    const regex = /^\s*(([^<>()[\],;:\s@"]+(\.[^<>()[\],;:\s@"]+)*)|(".+"))@(([^<>()[\],;:\s@"]+\.)+[^<>()[\],;:\s@"]{0,})\s*$/;
                                    const emails = e.target.value.split(/[,;]/).map(email => email.trim());
                                    for (let email of emails) {
                                        if (!regex.test(email)) {
                                            Swal.fire({
                                                icon: 'error',
                                                title: 'Correo inválido',
                                                text: `El correo ${email} no es válido.`
                                            });
                                            return;
                                        }
                                    }
                                }}
                                title="Si desea agregar varios correos, los separa por coma (,) o por punto y coma(;)"
                            />
                        </div>
                        <div className="col-50">
                            <span className="col-form-span" >Nombre Comercial</span>
                            <input type="text" id="NOMBRE_COMERCIAL" name="NOMBRE_COMERCIAL" autoComplete='off' value={Gestor.NOMBRE_COMERCIAL} onChange={Modificar}></input>

                        </div>
                    </div>
                    <div className="row">
                        <div className="col-25">

                            <span className="col-form-span" >Teléfono </span>
                            <input type="text" id="FAC_TELEFONO" name="FAC_TELEFONO" autoComplete='off' value={Gestor.FAC_TELEFONO} onChange={Modificar}></input>

                        </div>
                        <div className="col-25" style={{ display: 'flex', alignItems: 'center' }}>
                            <button id="Buscar" onClick={() => RefrescarActivides()} name="Buscar">Refresc. Atividades</button>
                        </div>
                        <div className="col-50">
                            <span className="col-form-span" >Actividades </span>
                            <select id="Actividad" name="Actividad" className="form-group" onChange={ModificarActividad} value={ActSelected}>
                                {ActividadesCli.map((option, i) => (
                                    <option key={i} value={option.CODIGO_ACTIVIDAD}>{option.CODIGO_ACTIVIDAD + '-' + option.NOMBRE_ACTIVIDAD}</option>
                                ))}
                            </select>
                        </div>
                        <div className="col-25">

                        </div>

                    </div>

                    <div className="row">
                        <div className="col-25">
                            <span className="col-form-span" >Provincia </span>
                            <select id="PROVINCIA" name="PROVINCIA" className="form-group" onChange={ZonaProvincia} value={Gestor.PROVINCIA}>
                                {Provincias.map((option, i) => (
                                    <option key={i} value={option.value}>{option.span}</option>
                                ))}
                            </select>
                        </div>
                        <div className="col-25">
                            <span className="col-form-span" >Cantón </span>
                            <select id="CANTON" name="CANTON" className="form-group" onChange={ZonaCanton} value={Gestor.CANTON}>
                                {Cantones.map((option, i) => (
                                    <option key={i} value={option.CANTON}>{option.NOMBRE}</option>
                                ))}
                            </select>
                        </div>
                        <div className="col-25">
                            <span className="col-form-span" >Distrito </span>
                            <select id="DISTRITO" name="DISTRITO" className="form-group" onChange={Modificar} value={Gestor.DISTRITO}>
                                {Distritos.map((option, i) => (
                                    <option key={i} value={option.DISTRITO}>{option.NOMBRE}</option>
                                ))}
                            </select>
                        </div>
                        <div className="col-25">
                            <span className="col-form-span" >Dirección </span>
                            <textarea id="OTRAS_DIRECCIONES" name="OTRAS_DIRECCIONES" cols={3} rows={3} value={Gestor.OTRAS_DIRECCIONES} onChange={Modificar}></textarea>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-25">
                            <span className="col-form-span" >Tarifa Diferenciada </span>
                            <select id="DE_TASA_IMP" name="DE_TASA_IMP" className="form-group" onChange={Modificar} value={Gestor.DE_TASA_IMP}>
                                {CodigosTarifasDiferenciadas.map((option, i) => (
                                    <option key={i} value={option.value}>{option.span}</option>
                                ))}</select>
                        </div>
                        <div className="col-25">
                            <span className="col-form-span" >Tipo Tributario </span>
                            <select id="TIPO_TRIBUTARIO" name="TIPO_TRIBUTARIO" className="form-group" onChange={Modificar} value={Gestor.TIPO_TRIBUTARIO}>
                                {tiposTributario.map((option, i) => (
                                    <option key={i} value={option.value}>{option.span}</option>
                                ))}</select>
                        </div>
                        <div className="col-25">

                        </div>
                    </div>
                    <div hidden={Gestor.TIPO_TRIBUTARIO === "1" || Gestor.TIPO_TRIBUTARIO === 1} className="row">
                        <div className="col-25">
                            <span className="col-form-span" >E.1 Tipo Documento </span>
                            <select id="ETipoDoc" name="ETipoDoc" className="form-group" onChange={Modificar} value={Gestor.ETipoDoc}>
                                {TiposDocumentoExoneracion.map((option, i) => (
                                    <option key={i} value={option.value}>{option.span}</option>
                                ))}
                            </select>
                        </div>
                        <div className="col-25">
                            <span className="col-form-span" >E.2 Num. Doc. </span>
                            <input type="text" id="ENumDoc" name="ENumDoc" autoComplete='off' value={Gestor.ENumDoc} onChange={Modificar}></input>
                        </div>
                        <div className="col-25">
                            <span className="col-form-span" >E.3 Fecha Emisión </span>
                            <input type="date" id="EFechaEmision" name="EFechaEmision" autoComplete='off' value={Gestor.EFechaEmision} onChange={Modificar}></input>
                        </div>
                        <div className="col-25">
                            <span className="col-form-span" >E.4 % Exoneración </span>
                            <input type="text" id="EPorcentaje" name="EPorcentaje" autoComplete='off' value={Gestor.EPorcentaje} onChange={Modificar}></input>
                        </div>
                    </div>
                    <div hidden={Gestor.TIPO_TRIBUTARIO === "1" || Gestor.TIPO_TRIBUTARIO === 1} className="row">
                        <div className="col-50">
                            <span className="col-form-span" >E.5 Institución </span>
                            
                            <select id="Einstitucion" name="Einstitucion" className="form-group" onChange={Modificar} value={Gestor.Einstitucion}>
                                {InstitucionesExoneran.map((option, i) => (
                                    <option key={i} value={option.value}>{option.span}</option>
                                ))}
                            </select>
                        </div>
                        <div className="col-25">
                            <span className="col-form-span" >E.6 Artículo </span>
                            <input type="text" id="Articulo" name="Articulo" autoComplete='off' value={Gestor.Articulo} onChange={Modificar}></input>
                        </div>
                        <div className="col-25">
                            <span className="col-form-span" >E.7 Inciso </span>
                            <input type="text" id="Inciso" name="Inciso" autoComplete='off' value={Gestor.Inciso} onChange={Modificar}></input>
                        </div>
                    </div>
                </div>
            </div>
        </div>)
    }
    else {
        return (<><p>Cargando Ficha Cliente...</p></>)
    }
}
export default FichaCliente